export const formatShortDate = (dateString: string) => new Date(dateString).toLocaleString().split(",")[0]
